import { bookService, projectService, attachmentService, commentService } from '@/services'
import { first, second, third, fourth, fifth, sixth } from './defaultTeamProjects'
import { generateHTML } from '@/core/helper-functions'
import createTemplate from './createTemplate'

const images = [
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/31543/1630863746814_375733825314918.jpg',
    name: 'first.jpg',
    type: 'image/jpeg'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/31543/1630863747220_375734231026559.jpg',
    name: 'second.jpg',
    type: 'image/jpeg'
  },
  {
    url: 'https://production-eu-uploads.s3.eu-central-1.amazonaws.com/196654/31543/1630863745800_375732811374816.gif',
    name: 'third.gif',
    type: 'image/gif'
  }
]

export default async (commit, settings, bookTitle = 'Executive team', subTitle = 'Where will we go? And how do we get there?', color = null) => {
  // create first book
  const book = await bookService.create({
    title: bookTitle,
    subTitle,
    color
  })

  commit('loading', true)

  const firstProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Getting started',
    icon: 'high-voltage',
    parentId: null,
    body: first(),
    html: generateHTML(first(), settings, 'Getting started')
  })

  const uploadedImages = {}

  for (const image of images) {
    commit('loading', true)

    const { data } = await attachmentService.proxy(image.url)

    const file = new File([data], image.name, { type: image.type })

    const formData = new FormData()
    formData.append('data', file, image.name)

    commit('loading', true)

    const response = await attachmentService.upload({
      projectId: firstProject.data.dataValues.id,
      data: formData
    })

    uploadedImages[image.name] = {
      id: response.data.id,
      url: response.data.url
    }
  }

  commit('loading', true)

  const comment1 = await commentService.create({
    body: 'This is a comment',
    parentId: null
  }, firstProject.data.dataValues.id)

  commit('loading', true)

  await commentService.create({
    body: 'Handy!',
    parentId: comment1.data.dataValues.id
  }, firstProject.data.dataValues.id)

  commit('loading', true)

  await projectService.edit(
    firstProject.data.dataValues.id,
    {
      title: 'Getting started',
      body: first(uploadedImages, comment1.data.dataValues),
      html: generateHTML(first(uploadedImages, comment1.data.dataValues), settings, 'Getting started')
    }
  )

  // create second project
  commit('loading', true)

  const secondProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'OKR',
    icon: 'purple_circle',
    parentId: null,
    body: second(),
    html: generateHTML(second(), settings, 'OKR')
  })

  // create third project
  commit('loading', true)

  const thirdProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: 'Meeting notes',
    icon: 'file-folder',
    parentId: null,
    body: third(),
    html: generateHTML(third(), settings, 'Meeting notes')
  })

  // create fourth project
  commit('loading', true)

  const fourthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: '5 sept',
    icon: 'spiral-notepad',
    parentId: thirdProject.data.dataValues.id,
    body: fourth(),
    html: generateHTML(fourth(), settings, '5 sept')
  })

  // create fifth project
  commit('loading', true)

  const fifthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: '12 sept',
    icon: 'spiral-notepad',
    parentId: thirdProject.data.dataValues.id,
    body: fifth(),
    html: generateHTML(fifth(), settings, '12 sept')
  })

  // create sixth project
  commit('loading', true)

  const sixthProject = await projectService.add({
    bookId: book.data.dataValues.id,
    title: '15 sept - standup',
    icon: 'spiral-notepad',
    parentId: thirdProject.data.dataValues.id,
    body: sixth(),
    html: generateHTML(sixth(), settings, '15 sept - standup')
  })

  const data = {
    bookId: book.data.dataValues.id,
    project1: fourthProject.data.dataValues.id,
    project2: fifthProject.data.dataValues.id,
    project3: sixthProject.data.dataValues.id
  }

  await projectService.edit(
    thirdProject.data.dataValues.id,
    {
      title: 'Meeting notes',
      body: third(data),
      html: generateHTML(third(data), settings, 'Meeting notes')
    }
  )

  // create templates
  commit('loading', true)
  await createTemplate(settings, secondProject.data.dataValues, true)
  commit('loading', true)
  await createTemplate(settings, fourthProject.data.dataValues, true)
}
